export const constructStrRep = (obj) => {
    return obj.str_representation || obj.title;
}
export const detailUrl = ({id}) => {
    return `/configcenter/categories/tags/${id}`;
}

export const overviewUrl = () => {
    return ``;
}